export const AdminLeaseDashboards = {
  AdminLeaseDashboards: 
  {
    permissionsId:'fda7d11b-92e6-420b-ee3d-08da65738802',
    permissionsName:'Admin Lease' , 
    componentsId:null,
    components:null
  }
} ;
